import React from 'react'
import TextRadioButton from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/TextRadioButton'

const UpdateReject = ({ selectedReason, setSelectedReason }) => {
  return (
    <div>
      <TextRadioButton
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
      />
    </div>
  )
}

export default UpdateReject
